import cls from 'classnames';

const styles = {
  heading: 'text-h4 text-red-light mb-2 teair:text-air-mediumBlue',
  text: 'text-overline text-gray-2 mb-8 md:mb-6',
  formGroup: 'md:flex items-start',
  link: 'underline teair:text-air-mediumBlue',
  inputWrapper: 'mb-4 md:mr-4',
  countryCodeSelect: (hasValue: boolean) =>
    cls(
      'w-[110px] rounded-2 py-3 px-4 leading-snug focus:shadow-none focus:ring-0',
      'text-red-light bg-black bg-opacity-50 border-transparent focus:border-gray-2',
      'tesn:bg-air-lila-light tesn:bg-opacity-20 teair:bg-air-mediumBlue',
      'truncate',
      hasValue && 'border-gray-2',
    ),
  input: (hasValue: boolean) => cls(hasValue && 'border-gray-2'),
  button: 'w-full mb-6 py-3',
  btnContainer: 'text-center md:text-left',
  cancelBtn: 'text-body2 text-gray-2 underline teair:text-air-mediumBlue',
};

export default styles;
